module.exports = __webpack_public_path__ + "img/P18.6964ba5d.png";